<script type="text/jsx">
import { mapGetters } from 'vuex'
export default {
  name: 'SectionNonWarrantyRepair',
  computed: {
    ...mapGetters({
      content: 'home/getContent'
    })
  },
  render () {
    return (
      <section class="non-warranty-repair">
        {this.content.lang_strings && <div class="non-warranty-repair__content">
          <h2 class="non-warranty-repair__title title">{ this.content.lang_strings.pricelist_title }</h2>
          <p class="non-warranty-repair__description text">{ this.content.lang_strings.pricelist_text }</p>
          <a class="non-warranty-repair__more" href="/upload/price.pdf" target="_blank">{ this.content.lang_strings.pricelist_show_button }
            <div class="non-warranty-repair__wrap-img">
              <svg class="non-warranty-repair__img" xmlns="http://www.w3.org/2000/svg" xlinkHref="http://www.w3.org/1999/xlink" width="8" height="8" viewBox="0 0 8 8">
                <defs>
                  <path id="1bhaa" d="M159.27 2464.64h5.93v5.93l-.89.9v-5.31l-5.72 5.72-.63-.63 5.72-5.72h-5.3z"></path>
                </defs>
                <g>
                  <g transform="translate(-158 -2464)">
                    <use fill="#999" xlinkHref="#1bhaa"></use>
                  </g>
                </g>
              </svg>
            </div>
          </a>
        </div> }
      </section>
    )
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Other/SectionNonWarrantyRepair.vue